const shouldNotForwardProps = prop => !['marginTop', 'marginLeft', 'marginRight', 'marginBottom', 'm', 'mr', 'mt', 'ml', 'mb', 'margin', 'marginX', 'marginY', 'mx', 'my'].includes(prop);

export { shouldNotForwardProps };
